import { adNoticeRepository } from '@/repositories/Index';


class AdNoticeService {
  // 消息通知列表
  async listFn(params: any) {
    const res = await adNoticeRepository.listFn(params)
    return res;
  }

  //通知详情
  async detailFn(params: any) {
    const res = await adNoticeRepository.detailFn(params)
    return res;
  }

  // xlog开关
  async getXLogStatus(params: any) {
    const res = await adNoticeRepository.getXLogStatus(params)
    return res;
  }

  async noticeRead(params: any) {
    const res = await adNoticeRepository.noticeRead(params)
    return res;
  }

}

export default AdNoticeService;
